var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"matrix_config"},[_c('base-form',{staticClass:"matrix_form",attrs:{"fields":_vm.fields,"btnText":"Update Matrix"},on:_vm._d({},[_vm.EVENTS.SUBMIT,_vm.submit])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }